import React, { useEffect, useState } from "react";
import axios from "axios";
import { createMRTColumnHelper } from "material-react-table";
import { baseUrl } from "../../../helper/urls";
import AdminCustomTable from "../../../components/custom_table/AdminCustomTable";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector } from "react-redux";

const Webinar = () => {
  const { token } = useSelector((state) => state.auth);
  const [webinars, setWebinars] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchWebinars = async () => {
      try {
        const response = await axios.get(
          `${baseUrl}/api/booking_req/webinarGetAll`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setWebinars(response.data.data);
      } catch (error) {
        console.error("Error fetching webinars:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchWebinars();
  }, []);

  const columnHelper = createMRTColumnHelper();
  const columns = [
    columnHelper.accessor("name", { header: "Student Name" }),
    columnHelper.accessor("email", { header: "Email" }),
    columnHelper.accessor("phone", {
      header: "Phone",
      Cell: (cell) =>
        `${cell.row.original.country_code || ""} ${
          cell.row.original.phone || "-"
        }`,
    }),
    columnHelper.accessor("message", { header: "Message" }),
    columnHelper.accessor("description", {
      header: "Description",
      Cell: (cell) => cell.row.original?.description || "-",
    }),
    // columnHelper.accessor("created_at", {
    //   header: "Created At",
    //   Cell: (cell) =>
    //     cell.row.original?.created_at
    //       ? cell.row.original?.created_at.split("T")[0]
    //       : "-",
    // }),
  ];

  return (
    <div>
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="mt-10">
        <AdminCustomTable columns={columns} data={webinars} loading={loading} />
      </div>
    </div>
  );
};

export default Webinar;
